import React from 'react';
import {AutoComplete, Checkbox, DatePicker, Form, Input, InputNumber, Select, Switch} from "antd";
import dayjs from "dayjs";
import {rangePresets, valueInput} from "./component";

const {RangePicker} = DatePicker;
const {TextArea} = Input;

const FormItems = ({formItems = []}) => {

    return (
        <>
            {formItems.map(({
                                label,
                                name,
                                type,
                                required,
                                message,
                                disabled,
                                allowClear,
                                placeholder,
                                inputValue,
                                options,
                                formItemStyle,
                                inputStyle,
                                formatter,
                                format = 'YYYY-MM-DD',
                                fromDate,
                                toDate,
                                onSearch = (val) => {},
                                ...arg
                            }, index) => (
                // <Form.Item noStyle shouldUpdate>
                //     {() => (
                <Form.Item
                    key={index}
                    name={name}
                    hidden={arg.hidden}
                    {...((type === "checkbox" || type === "switch") ? {valuePropName: "checked", ...(type === "switch" ? {label} : {})} : {label})}
                    style={formItemStyle || {}}
                    rules={[{required: required || false, message: message || ""}]}
                >
                    {type === 'number' ?
                        <InputNumber
                            size={"large"}
                            min={arg.min || 0}
                            max={arg.max || Number.MAX_SAFE_INTEGER}
                            className={"w-100"}
                            placeholder={placeholder}
                            disabled={disabled ?? false}
                            prefix={arg.prefix}
                            addonAfter={arg.addonAfter}
                            addonBefore={arg.addonBefore}
                            formatter={(value) => formatter ? `${valueInput(value)}` : value}
                            style={inputStyle || {}}
                        />
                        : type === "date" ?
                            <DatePicker format={format} className={"w-100"}
                                        alloeClear={allowClear}
                                        size={"large"}
                                        placeholder={placeholder}
                                        style={inputStyle || {}}
                                        defaultPickerValue={fromDate ? dayjs(fromDate, format) : undefined}
                                        disabledDate={fromDate && toDate ? (current) => {
                                            return dayjs(fromDate || undefined, format).add(-1, 'days') >= current ||
                                                dayjs(toDate || undefined, format).add(1, 'days') <= current;
                                        } : undefined}
                            />
                            : type === "autocomplete" ?
                                <AutoComplete
                                    options={options ?? []}
                                    size={"large"}
                                    style={inputStyle || {}}
                                    placeholder={placeholder}
                                    allowClear={allowClear}
                                    disabled={disabled ?? false}
                                    onSearch={onSearch}
                                    filterOption={(inputValue, option) => option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1}
                                />
                                : type === "autocompleteNumber" ?
                                    <AutoComplete
                                        size={"large"}
                                        options={options ?? []}
                                        disabled={disabled ?? false}
                                        placeholder={placeholder}
                                        style={inputStyle || {}}
                                        filterOption={(inputValue, option) => option.value.indexOf(inputValue) !== -1}
                                    >
                                        <InputNumber className={"w-100"}
                                                     formatter={(value) => formatter ? `${valueInput(value)}` : value}
                                        />
                                    </AutoComplete>
                                    : type === "select" ?
                                        <Select
                                            size={"large"}
                                            showSearch
                                            defaultActiveFirstOption={false}
                                            allowClear={allowClear}
                                            disabled={disabled ?? false}
                                            placeholder={placeholder}
                                            {...(arg.mode ? {mode: arg.mode} : {})}
                                            fieldNames={{label: "name", value: "id"}}
                                            filterOption={(input, option) =>
                                                (option?.name ?? "")?.toLowerCase().includes(input?.toLowerCase())
                                            }
                                            style={inputStyle || {}}
                                            options={options?.length ? options : []}
                                        />
                                        : type === "password" ?
                                            <Input.Password
                                                size={"large"}
                                                allowClear={allowClear}
                                                prefix={arg.prefix}
                                                addonAfter={arg.addonAfter}
                                                addonBefore={arg.addonBefore}
                                                disabled={disabled ?? false}
                                                placeholder={placeholder}
                                                style={inputStyle || {}}
                                            />
                                            : type === "rangePicker" ?
                                                <RangePicker presets={rangePresets} format={format}
                                                             className={"w-100"}
                                                             size={"large"}
                                                             allowClear={allowClear}
                                                             style={inputStyle || {}}
                                                             defaultPickerValue={fromDate ? dayjs(fromDate, format) : undefined}
                                                             disabledDate={fromDate && toDate ? (current) => {
                                                                 return dayjs(fromDate || undefined, format).add(-1, 'days') >= current ||
                                                                     dayjs(toDate || undefined, format).add(1, 'days') <= current;
                                                             } : undefined}
                                                />
                                                : type === "textarea" ?
                                                    <TextArea rows={arg.rows || 1}
                                                              size={"large"}
                                                              autoSize={arg.autoSize || false}
                                                              maxLength={arg.maxLength || null}
                                                              showCount={arg.showCount || false}
                                                              disabled={disabled ?? false}
                                                              allowClear={allowClear}
                                                              style={inputStyle || {}}
                                                    />
                                                    : type === "checkbox" ?
                                                        <Checkbox
                                                            size={"large"}
                                                            disabled={disabled ?? false}>{label}</Checkbox>
                                                        : type === "switch" ?
                                                            <Switch
                                                                size={"default"}
                                                                disabled={disabled ?? false}/>
                                                            : <Input
                                                                size={"large"}
                                                                prefix={arg.prefix}
                                                                disabled={disabled ?? false}
                                                                placeholder={placeholder}
                                                                allowClear={allowClear}
                                                                addonAfter={arg.addonAfter}
                                                                addonBefore={arg.addonBefore}
                                                                hidden={arg.hidden}
                                                                maxLength={arg.max || 255}
                                                                minLength={arg.min || 0}
                                                                style={inputStyle || {}}
                                                            />
                    }
                </Form.Item>
                //     )}
                // </Form.Item>
            ))}
        </>
    );
};

export default FormItems;